import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from 'Components/Worksheets/QestIds';
import { BsEnMeasurementSection, BsEnPreparationSection, BsEnResultsSection } from './Sections';

const qestIds = [ids.particleDensity.BS_EN_1097_6_Clause_7.rev2022];

const BsEnParticleDensityWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Test Portion Preparation">
        <BsEnPreparationSection />
      </PageSection>
      <PageSection heading="Measurements">
        <BsEnMeasurementSection />
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <WorksheetResultsSection heading="Results">
        <BsEnResultsSection />
      </WorksheetResultsSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

BsEnParticleDensityWorksheet.qestIds = qestIds;

export default BsEnParticleDensityWorksheet;
export { BsEnParticleDensityWorksheet };
